import { Platform } from 'react-native';
import { translate } from 'secullum-i18n';
import { isTablet } from 'secullum-react-native-ui';
import { Container } from 'unstated';
import Api from '../modules/api';
import { getTheme, isHighResolution } from '../modules/layout';
import {
  InconsistenciasDados,
  InconsistenciasStatus,
  InconsistenciasFiltrosStatus,
  InconsistenciasFiltros
} from '../modules/types';

export interface State {
  lista: Array<InconsistenciasDados>;
  erro: string;
  erroConexao: boolean;
  onTentarNovamente: (() => void) | null;
}

const theme = getTheme();

export const getIconeStatus = (status: InconsistenciasStatus) => {
  switch (status) {
    case InconsistenciasStatus.Aceita:
      return 'thumbs-up';
    case InconsistenciasStatus.Descartada:
      return 'thumbs-down';
    case InconsistenciasStatus.Justificada:
      return 'check';
    default:
      return 'hourglass-half';
  }
};

export const getCorStatus = (status: InconsistenciasStatus) => {
  switch (status) {
    case InconsistenciasStatus.Aceita:
      return theme.successColor;
    case InconsistenciasStatus.Descartada:
      return theme.errorColor;
    case InconsistenciasStatus.Justificada:
      return theme.textColor3;
    default:
      return theme.warningColor;
  }
};

export const getItensStatusInconsistencias = () => {
  return [
    {
      nativeID: 'inconsistencias-filtros-todas',
      value: InconsistenciasFiltrosStatus.Todos,
      label: translate('Todas')
    },
    {
      nativeID: 'inconsistencias-filtros-processadas',
      value: InconsistenciasFiltrosStatus.Processados,
      label: translate('Aceitas') + '/' + translate('Rejeitadas')
    },
    {
      nativeID: 'inconsistencias-filtros-pendentes',
      value: InconsistenciasFiltrosStatus.Pendentes,
      label: translate('Aguardando Retorno')
    },
    {
      nativeID: 'inconsistencias-filtros-justificadas',
      value: InconsistenciasFiltrosStatus.Justificadas,
      label: translate('Justificadas')
    }
  ];
};

export const getTamanhoFonte = () => {
  if (Platform.OS === 'web') {
    return 14;
  }

  if (isTablet()) {
    return 15;
  }

  return 12;
};

export const getLarguraCampoData = () => {
  if (Platform.OS === 'web') {
    return isHighResolution() ? 200 : 70;
  }

  if (isTablet()) {
    return 75;
  }

  return 65;
};

export class InconsistenciasContainer extends Container<State> {
  state: State = {
    lista: [],
    erro: '',
    erroConexao: false,
    onTentarNovamente: null
  };

  loadAsync = async (filtros: InconsistenciasFiltros) => {
    const api = new Api();

    await api.getInconsistencias(filtros, {
      onSuccess: async (lista: Array<InconsistenciasDados>) => {
        this.setState({
          lista
        });
      },
      onError: (err: Error) => {
        this.setState({
          erro: err.message,
          erroConexao: err.name === 'TimeoutError',
          onTentarNovamente: () => this.loadAsync(filtros)
        });
      }
    });
  };

  limparErro = () => {
    this.setState({
      erro: '',
      erroConexao: false,
      onTentarNovamente: null
    });
  };
}

export default new InconsistenciasContainer();
